/** Categorías de auditoría — extraídas a archivo propio para evitar dependencia circular. */

export type AuditCategory =
  | 'team'
  | 'cash'
  | 'sales'
  | 'catalog'
  | 'stock'
  | 'expenses'
  | 'fiado'
  | 'promotions'
  | 'branch'
  | 'session';

export const AUDIT_CATEGORY_LABELS: Record<AuditCategory, string> = {
  team: 'Equipo',
  cash: 'Caja',
  sales: 'Ventas',
  catalog: 'Catálogo',
  stock: 'Stock',
  expenses: 'Gastos',
  fiado: 'Clientes',
  promotions: 'Promociones',
  branch: 'Sucursal',
  session: 'Sesión',
};

export function categorizeEventType(eventType: string): AuditCategory {
  if (eventType.startsWith('employee') || eventType.startsWith('invitation') || eventType === 'register.success') return 'team';
  if (eventType.startsWith('reports.cash') || eventType.startsWith('reports.external_service') || eventType === 'pos.external_service.create') return 'cash';
  if (eventType.startsWith('pos.sale') || eventType.startsWith('pos.promotion')) return 'sales';
  if (eventType.startsWith('catalog')) return 'catalog';
  if (eventType.startsWith('stock')) return 'stock';
  if (eventType.startsWith('expense')) return 'expenses';
  if (eventType.startsWith('fiado')) return 'fiado';
  if (eventType.startsWith('promotions')) return 'promotions';
  if (eventType.startsWith('branch.settings')) return 'branch';
  if (eventType.startsWith('login') || eventType.startsWith('logout')) return 'session';
  return 'team';
}

/**
 * Supabase filter fragments for each category.
 * Returns an array of `{ column, operator, value }` that can be applied via `.or()`.
 * Uses `like` (case-sensitive) on event_type prefixes.
 */
export function categoryToFilter(category: AuditCategory): string {
  switch (category) {
    case 'team':
      return 'event_type.like.employee.*,event_type.like.invitation.*,event_type.eq.register.success';
    case 'cash':
      return 'event_type.like.reports.cash.*,event_type.like.reports.external_service.*,event_type.eq.pos.external_service.create';
    case 'sales':
      return 'event_type.like.pos.sale.*,event_type.like.pos.promotion.*';
    case 'catalog':
      return 'event_type.like.catalog.*';
    case 'stock':
      return 'event_type.like.stock.*';
    case 'expenses':
      return 'event_type.like.expense.*';
    case 'fiado':
      return 'event_type.like.customer.*';
    case 'promotions':
      return 'event_type.like.promotions.*';
    case 'branch':
      return 'event_type.like.branch.settings.*';
    case 'session':
      return 'event_type.like.login.*,event_type.like.logout.*';
  }
}
